import { fetchReducerFactory } from '../../../shared/store/fetchFactory';

import {
  FETCH_SCENARIO_DETAILS,
  CREATE_SCENARIO_DETAIL,
  EDIT_SCENARIO_DETAIL,
  REMOVE_SCENARIO_DETAIL,
} from './types';
import initialState from './initialState';

const fetchReducer = fetchReducerFactory({
  [FETCH_SCENARIO_DETAILS]: 'ScenarioDetails',
  [CREATE_SCENARIO_DETAIL]: 'CreateScenarioDetail',
  [EDIT_SCENARIO_DETAIL]: 'UpdateScenarioDetail',
  [REMOVE_SCENARIO_DETAIL]: 'RemoveScenarioDetail',
},
initialState
, 'scenarioDetails'
);

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return fetchReducer(state, action);
  }
};

export default reducer;
